// src/pages/PartnersDetailPage.jsx
import React, {useEffect, useState} from 'react';
import '../styles/App.css';
import "../styles/Partner.css";
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import {useParams, useNavigate, useLocation} from "react-router-dom";
import {fetchPartnerData} from "../utils/functions"; // Changed to partner data fetcher

function PartnersDetailPage() {
    const { partnerName } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [currentPartner, setCurrentPartner] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";

        const loadData = async () => {
            try {
                const data = await fetchPartnerData(lang);
                if (isMounted) {
                    // Find partner by slugified name
                    const foundPartner = data.find(partner =>
                        partner.name.toLowerCase().split(" ").join("-") === partnerName
                    );
                    setCurrentPartner(foundPartner || null);
                }
            } catch (error) {
                console.error('Error loading partner data:', error);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [location.pathname, partnerName]);

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    if (!currentPartner) {
        return (
            <>
                <Navbar />
                <div className="container py-5 text-center">
                    <h2>Partner Not Found</h2>
                    <button
                        className="btn btn-primary mt-3"
                        onClick={() => navigate("/partners")}
                    >
                        Back to Partners
                    </button>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar/>

            <div className="partner-banner-top">
                <button
                    className="partner-back-btn"
                    onClick={() => navigate("/partners")}
                >
                    &lt;
                </button>
                <h1 className="partner-banner-title">{currentPartner.name}</h1>
            </div>

            <div
                className="partner-detail-banner"
                style={{backgroundImage: `url(${currentPartner.imagebg})`}}
            >
            </div>

            {/* About Section */}
            <div className="partner-detail-content container">
                <div className="row align-items-center">
                    <div className="col-lg-7 mb-4 mb-lg-0">
                        <h2 className="fw-bold">About</h2>
                        <p>{currentPartner.description}</p>
                    </div>
                    <div className="col-lg-5 text-center align-self-start">
                        <img
                            src={currentPartner.image}
                            alt={currentPartner.name}
                            className="partner-detail-logo"
                        />
                    </div>
                </div>
            </div>

            <Footer/>
        </>
    );
}

export default PartnersDetailPage;